import React, { useState } from "react"
import { Grid } from "src/UILibrary"

interface Props {
  name: string
  size: number
  sortby: string
  onSortChanged: any
}

export const NewsTableHeaderItem = ({ name, size, sortby, onSortChanged }: Props) => {
  const [asc, setAsc] = useState(true)
  const onSort = (sort: string, asc: boolean) => {
    onSortChanged(sort, asc)
    setAsc(!asc)
  }
  return (
    <Grid
      item
      className="notosans weight500"
      color="text.primary"
      md={size}
      sm={12}
      xs={12}
      fontSize={12}
      sx={{ my: "auto", px: "20px", ":hover": { opacity: 0.8, cursor: "pointer" } }}
      onClick={() => onSort(sortby, asc)}
    >
      {name}&nbsp;{asc ? "▼" : "▲"}
    </Grid>
  )
}
